import { useUserContext } from '@vp/ubik-context'
import { useTracking } from '../components/root/contexts/TrackingContext'
import { useProject } from '../components/root/contexts/ProjectContext'

export const useFeatureFlag = (featureFlag: string) => {
  const { isSizedGood } = useProject()
  const { trackFeatureFlag } = useTracking()
  const featureFlagValue = useUserContext().featureFlags?.[featureFlag]

  if (isSizedGood) return false

  trackFeatureFlag(featureFlag)
  return featureFlagValue !== undefined && featureFlagValue !== 'false'
}
